import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hospitals-facilities-clients',
  templateUrl: './hospitals-facilities-clients.component.html',
  styleUrls: ['./hospitals-facilities-clients.component.css']
})
export class HospitalsFacilitiesClientsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
